import { Component } from '@theme/component';

/**
 * @typedef {Object} CustomSliderCollectionRefs
 * @property {HTMLElement[]} slides
 * @property {HTMLButtonElement} previousButton
 * @property {HTMLButtonElement} nextButton
 */

/** @extends {Component<CustomSliderCollectionRefs>} */
class CustomSliderCollection extends Component {
  #current = 0;

  connectedCallback() {
    super.connectedCallback();
    const start = Number(this.dataset.startIndex) || 0;
    this.#current = this.#clamp(start);
    this.#render();
  }

  previous() {
    this.#current = this.#wrap(this.#current - 1);
    this.#render();
  }

  next() {
    this.#current = this.#wrap(this.#current + 1);
    this.#render();
  }

  get #count() {
    return this.refs.slides?.length ?? 0;
  }

  #wrap(index) {
    const count = this.#count;
    if (count === 0) return 0;
    return ((index % count) + count) % count;
  }

  #clamp(index) {
    const count = this.#count;
    if (count === 0) return 0;
    return Math.max(0, Math.min(index, count - 1));
  }

  #render() {
    const slides = this.refs.slides ?? [];
    const count = slides.length;
    if (count === 0) return;

    const current = this.#current;
    const prev = this.#wrap(current - 1);
    const next = this.#wrap(current + 1);

    slides.forEach((slide, index) => {
      let position = 'hidden';
      if (index === current) position = 'current';
      else if (index === prev) position = 'previous';
      else if (index === next) position = 'next';

      slide.dataset.position = position;
      slide.setAttribute('aria-hidden', position === 'hidden' ? 'true' : 'false');
    });
  }
}

if (!customElements.get('custom-slider-collection')) {
  customElements.define('custom-slider-collection', CustomSliderCollection);
}
